import {useStyletron} from "baseui";
import {SpaceTopAndBottom} from "../z40-uicomp/layout";
import {HeadingSmall} from "baseui/typography";
import * as React from "react";

export function PricingPane({children, title, reduceTitleSpacing, reduceBottomSpacing, overlay, backgroundColor}) {
    const [css, theme] = useStyletron();

    const defaultPadding = typeof theme.sizing.scale600 === 'string' 
        ? parseInt(theme.sizing.scale600) 
        : theme.sizing.scale600;
    const titleBottomPadding = reduceTitleSpacing 
        ? (defaultPadding - 10) + 'px'
        : theme.sizing.scale600;

    return (
    <div className={css({
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        border: '1px solid rgba(112, 128, 144, 0.3)',
        borderRadius: '8px',
        padding: '20px',
        ...(backgroundColor && { backgroundColor })
    })}>
        {overlay && (
            <div className={css({
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                zIndex: 10,
                pointerEvents: 'none',
                borderRadius: '8px'
            })} />
        )}
        <div className={css({
            paddingTop: '6px',
            paddingBottom: reduceTitleSpacing ? (defaultPadding - 10) + 'px' : theme.sizing.scale600
        })}>
            <div className={css({
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'
            })}>
                <HeadingSmall>{title}</HeadingSmall>
            </div>
        </div>
        <div className={css({
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            paddingBottom: reduceBottomSpacing ? '8px' : undefined
        })}>
            {children}
        </div>
    </div>
    );
}